'use client';

import React from 'react';

import Icon from '../../_ui/_blocks/Icon/Icon';
import Typography from '../../_ui/_blocks/Typography/Typography';

import styles from './BookmarkNavigation.module.css';

interface Props {
    className?: string;
    data: Array<{
        link: string; // #cqc
        label: string; // CQC
    }>;
}

const BookmarkNavigation = ({ className, data }: Props) => (
    <nav className={`${className || ''} ${styles.bookmark}`}>
        <Typography as="h4" typeset="heading" size="100" className="p-075">
            Table of contents
        </Typography>
        <ul className="flex flex-col">
            {data.map(({ link, label }, index) => (
                <li key={index}>
                    <a className={styles.bookmarkNavItem} href={link}>
                        {label}
                        <Icon
                            icon="chevron-right-light"
                            alt=""
                            aria-hidden="true"
                            size="xsmall"
                            className="flex-shrink-0"
                        />
                    </a>
                </li>
            ))}
        </ul>
    </nav>
);

export default BookmarkNavigation;
